import { NgComponentOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, Injector, input, output, Type, } from '@angular/core';
import { ALLOWED_INPUTS_BY_TYPE, CHART_TYPES, ChartTypes, } from '../../constants/chart.constants';
import { ChartOptions, ChartType } from '../../models/chart.models';
import { ChartHeader } from './chart.header';
import { ChartCommon } from './chart.common';
import { CHANGE_VISIBILITY_TOKEN } from '../line/line.chart';

@Component({
  selector: 'chart',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgComponentOutlet, ChartHeader],
  template: `
    <div class="flex flex-col" [class]="{ 'gap-y-6': title() || subtitle() }">
      <chart-header [title]="title()" [subtitle]="subtitle()" />
      <ng-container
        *ngComponentOutlet="
          chartComponent();
          inputs: combinedInputs();
          injector: injector
        "
      >
      </ng-container>
    </div>
  `,
})
export class ChartComponent extends ChartCommon {
  private readonly CHARTS = CHART_TYPES;
  private readonly DEFAULT_CHART_TYPE: ChartType = ChartTypes.Gauge;

  injector = Injector.create({
    providers: [
      {
        provide: CHANGE_VISIBILITY_TOKEN,
        useValue: (data: any) => this.changeVisibility.emit(data),
      },
    ],
  });

  changeVisibility = output<any>();

  type = input<ChartType>(this.DEFAULT_CHART_TYPE);
  typeInputs = input<{ [key: string]: any }>({});
  options = input<ChartOptions>();

  chartComponent = computed(() => this.getChart(this.type()));
  baseInputs = computed(() => ({
    // Add here common inputs
    options: this.options(),
  }));
  combinedInputs = computed(() => ({
    ...this.baseInputs(),
    ...this.filterTypeInputs(this.type(), this.typeInputs()),
  }));

  private getChart(type: ChartType): Type<unknown> | null {
    return this.CHARTS[type] || null;
  }

  private filterTypeInputs(
    type: ChartType,
    inputs: { [key: string]: any },
  ): { [key: string]: any } {
    const allowedInputs = ALLOWED_INPUTS_BY_TYPE[type] || [];
    return Object.keys(inputs)
      .filter((key) => allowedInputs.includes(key))
      .reduce(
        (acc, key) => {
          acc[key] = inputs[key];
          return acc;
        },
        {} as { [key: string]: any },
      );
  }
}
